module.exports = __webpack_public_path__ + "img/badge-cc.bef1ff34.svg";